<template>
  <button
    class="flex min-w-[112px] items-center space-x-1 rounded-md bg-gpx_terracotta-300 hover:bg-gpx_terracotta-200 text-white font-medium rounded px-3 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-gpx_terracotta-300"
    @click="toggleState"
    :aria-expanded="isOpen ? 'true' : 'false'"
    tabindex="0"
    @keydown.enter="toggleState"
    @keydown.space="toggleState"
  >
    <img :src="MyIconSrc" class="h-5 w-5" />

    <span>Ask&nbsp;Scout</span>
  </button>
</template>

<script setup lang="ts">
import  MyIconSrc from '@/assets/scout/white.svg'
import { useSidebarIsOpen } from "@/composables/useSidebarIsOpen";
import {RIGHT_SIDEBAR} from "@/types/ui";
const isOpen = useSidebarIsOpen(RIGHT_SIDEBAR, true);
import * as event from '@/events';

function toggleState() {
  isOpen.value = !isOpen.value;
  event.trigger(event.names.SCOUT_TOGGLED);
}
</script>
